import type { SystemStyleObject } from '@chakra-ui/react';

export const mainCss: SystemStyleObject = {
  '&': {
    display: 'flex',
    minHeight: 'dvh',
    width: 'full',
    bg: 'bg',
  },

  '& .main-column': {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    bgGradient: 'to-b',
    gradientFrom: 'bg.subtle',
    gradientVia: 'bg',
    gradientTo: 'bg',
  },

  '& main': {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    paddingTop: 5,
    paddingBottom: 12,

    '& > *': { flex: 1 },
  },
};
